import { Union } from "../fable-library-js.4.24.0/Types.js";
import { union_type, string_type, class_type } from "../fable-library-js.4.24.0/Reflection.js";
import { keyValueList } from "../fable-library-js.4.24.0/MapUtil.js";
import { Types_HttpRequestHeaders } from "../Fable.Fetch.2.7.0/Fetch.fs.js";
import { append, cons } from "../fable-library-js.4.24.0/List.js";
import { map, defaultArg } from "../fable-library-js.4.24.0/Option.js";
import { int32ToString } from "../fable-library-js.4.24.0/Util.js";

export class FetchError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PreparingRequestFailed", "DecodingFailed", "FetchFailed", "NetworkError"];
    }
}

export function FetchError_$reflection() {
    return union_type("Thoth.Fetch.FetchError", [], FetchError, () => [[["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item", class_type("Fetch.Types.Response")]], [["Item", class_type("System.Exception")]]]);
}

export function Helper_fetch(url, init) {
    return fetch(url, keyValueList(init, 1));
}

export function Helper_withContentTypeJson(data, headers) {
    if (data != null) {
        return cons(new Types_HttpRequestHeaders(11, ["application/json"]), headers);
    }
    else {
        return headers;
    }
}

export function Helper_withProperties(custom, properties) {
    return defaultArg(map((list) => append(properties, list), custom), properties);
}

export function Helper_message(error) {
    switch (error.tag) {
        case 1:
            return "[Thoth.Fetch] Error while decoding the response:\n\n" + error.fields[0];
        case 2: {
            const response = error.fields[0];
            return (((("[Thoth.Fetch] Request failed:\n\n" + int32ToString(response.status)) + " ") + (response.statusText)) + " for URL ") + (response.url);
        }
        case 3:
            return "[Thoth.Fetch] A network error occured:\n\n" + error.fields[0].message;
        default:
            return "[Thoth.Fetch] Request preparation failed:\n\n" + error.fields[0].message;
    }
}

export class Fetch {
    constructor() {
    }
}

export function Fetch_$reflection() {
    return class_type("Thoth.Fetch.Fetch", undefined, Fetch);
}

